import ResumeRealityCheckerV2 from './ScoringV2.js';

export default ResumeRealityCheckerV2;
export { ResumeRealityCheckerV2 }; 